import styled from '@emotion/styled'

interface TagProps {
  color: string
}

/**
 * Tag component used by V2 scope picker (select-partner/MenuOption)
 */
export const Tag = styled.div<TagProps>(({ color }) => ({
  flexShrink: 0,
  margin: '8px 8px',
  padding: '4px 8px',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  textAlign: 'center',
  // marginLeft: 'auto',
  marginRight: 0,
  backgroundColor: color,
}))
